import React from 'react';
import * as PropTypes from 'prop-types';
import Layout from './Layout';
import noResultImage from './no-result.png';

ErrorNoResult.propTypes = {
  tips: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]),
  onBtnClick: PropTypes.func,
  btnText: PropTypes.string
};

export default function ErrorNoResult(props) {
  const {
    tips, onBtnClick, btnText, ...rest
  } = props;
  return (
    <Layout
      image={noResultImage}
      tips={tips}
      onBtnClick={onBtnClick}
      btnText={btnText}
      {...rest}
    />
  );
}
